import * as React from "react";
import { Placeholder } from "kanopi-components/Placeholder";
import { NoContentMessage } from "kw/components/NoContentMessage/NoContentMessage";
import { Block } from "kanopi-components/Block/Block";
import {
  PolicySummaryCard,
  TPolicySummaryCardBuilder,
} from "kw/policies/components/PolicySummaryCard";

type TPolicyList = {
  policies: Array<TPolicy>;
  loading: boolean;
  noContentMessage: string;
  cardBackgroundColor?: string;
} & TPolicySummaryCardBuilder;

export const PolicyListing: React.FC<TPolicyList> = ({
  policies,
  loading = false,
  noContentMessage,
  cardBackgroundColor,
  ...PolicySummaryCardProps
}) => {
  return (
    <Placeholder loading={loading}>
      {policies.length == 0 ? (
        <NoContentMessage message={noContentMessage} />
      ) : (
        <Block
          gridColumnGap="scale800"
          gridRowGap="scale900"
          display="flex"
          flexWrap={true}
          justifyContent="center"
        >
          {policies.map((policy) => (
            <PolicySummaryCard
              key={`PolicySummaryCard-${policy.id}`}
              policy={policy}
              {...PolicySummaryCardProps}
              backgroundColor={cardBackgroundColor}
            />
          ))}
        </Block>
      )}
    </Placeholder>
  );
};
